import { LOGO_URL, SITE_NAME } from '@/lib/constants'
import WhatsAppButton from '@/components/WhatsAppButton'

function Header() {
  return (
    <header className="fixed top-0 inset-x-0 z-40 bg-white/90 backdrop-blur-md border-b border-slate-100">
      <div className="max-w-6xl mx-auto px-6 sm:px-8 h-20 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-3" aria-label={SITE_NAME}>
          <img
            src={LOGO_URL}
            alt="Muita Mídia"
            className="h-9 w-auto object-contain"
          />
        </a>
        <WhatsAppButton label="Falar no WhatsApp" variant="primary" size="md" />
      </div>
    </header>
  )
}

export default Header
